import React from "react";
import { Box, Divider, Typography } from "@mui/material";

const SectionTitle = ({ title }) => {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        marginTop: 5,
      }}
    >
      <Typography
        sx={{
          color: (theme) => theme.palette.blackPro,
          fontWeight: "bold",
          fontSize: "28px",
          marginBottom: 1,
        }}
      >
        {title}
      </Typography>
      <Divider
        variant="divider"
        fullWidth
        sx={{
          marginBottom: 2,
        }}
      />
    </Box>
  );
};

export default SectionTitle;
